// Actions
export const PAGEVISIBILITY = "global/PAGEVISIBILITY";
export const FONTLOADING = "global/FONTLOADING";

// scopeReducers

// Reducer
export default function reducer(state = { areFontsLoaded: false }, { type, data } = {}) {
    switch (type) {
    case "@@INIT": {
        return { ...state, init: true, isPageVisibile: true, areFontsLoaded: false };
    }
    case PAGEVISIBILITY:
        return {
            ...state,
            isPageVisibile: data.isPageVisibile
        };
    case FONTLOADING:
        return { ...state, areFontsLoaded: true };
    default: return state;
    }
}

// Action Creators
export function markPageVisible(isPageVisibile) {
    return { type: PAGEVISIBILITY, data: { isPageVisibile } };
}

export function markFontsAsLoaded() {
    return { type: FONTLOADING };
}
